<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";
import {EditableArea} from "@magnolia/vue-editor";

const props = defineProps<{
  measurementsArea: Area;
  metadata: Area;
  body?: string;
}>();

provide("amountOfSiblings", props.measurementsArea["@nodes"].length);
</script>

<template>
  <div class="article-margin">
    <EditableArea
      v-if="measurementsArea"
      :content="measurementsArea"
      class="measurements flex flex-col gap-4 lg:inner-content-grid">
    </EditableArea>
  </div>
</template>

<style lang="scss" scoped></style>
